// スライダー
import slick from "slick-carousel";

export function idxFunc() {
  if (!$("#indexTop").length) return;

  // slideArea1
  const $slider1 = $(".slideArea1");

  if ($slider1.length && !$slider1.hasClass("slick-initialized")) {
    $slider1.slick({
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 400,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      fade: false,
      infinite: true,
      pauseOnTouchMove: false,
      pauseOnHover: false,
      nextArrow:
        '<img src="/s/garrack/feature/chainsawman2026/images/common/slide_arrows_next.svg" class="slide-arrow next-arrow">',
      prevArrow:
        '<img src="/s/garrack/feature/chainsawman2026/images/common/slide_arrows_prev.svg" class="slide-arrow prev-arrow">',
    });

    // dotsにclass付与
    $slider1.find(".slick-dots li").each(function (index) {
      $(this).addClass(`dot-${index + 1}`);
    });
  }

  // slideArea2
  const $slider2 = $(".slideArea2");

  if ($slider2.length && !$slider2.hasClass("slick-initialized")) {
    $slider2.slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 400,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      fade: false,
      infinite: true,
      pauseOnTouchMove: false,
      pauseOnHover: false,
      nextArrow:
        '<img src="/s/garrack/feature/chainsawman2026/images/common/slide_arrows_next.svg" class="slide-arrow next-arrow">',
      prevArrow:
        '<img src="/s/garrack/feature/chainsawman2026/images/common/slide_arrows_prev.svg" class="slide-arrow prev-arrow">',
    });

    // dotsにclass付与
    $slider2.find(".slick-dots li").each(function (index) {
      $(this).addClass(`dot-${index + 1}`);
    });
  }
}